import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import { GetLocationsResponseDto } from "../generated/generatedTypes";
import { getApiErrorMessage } from "../getApiErrorMessage";

export const useGetLocations = () => {
  return useQuery({
    queryKey: ["locations", "admin"],
    queryFn: async (): Promise<GetLocationsResponseDto> => {
      const response = await apiFetch("api/admin/locations");
      if (!response.ok) {
        throw new Error(await getApiErrorMessage(response));
      }
      return response.json();
    },
  });
};
